export default import.meta.ROLLUP_FILE_URL_Jhiobz1iAIl42UC3k5$exQ;